import { render, staticRenderFns } from "./QuestionsBlock.vue?vue&type=template&id=68f01256&"
import script from "./QuestionsBlock.vue?vue&type=script&lang=js&"
export * from "./QuestionsBlock.vue?vue&type=script&lang=js&"
import style0 from "./QuestionsBlock.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports